import { SiteData } from "../shared/types";

export const siteData: SiteData = {
  organizations: [
    {
      title: "Sebastiano Caputo",
      subtitle: "Fondatore e Presidente del Cda",
    },
    {
      title: "Davide Brullo",
      subtitle: "Consigliere, Direttore Editoriale di Pangea",
    },
    {
      title: "Andrea Petolicchio",
      subtitle: "Consigliere",
    },
    {
      title: "Fabrizia Sabbatini",
      subtitle: "Co-direttrice delle collane editoriali Magog",
    },
    {
      title: "Davide Arcidiacono",
      subtitle: "Caporedattore di Dissipatio",
    },
    {
      title: "Ranpo Fahreneit",
      subtitle: "Direttore editoriale di Blast",
    },
    {
      title: "Andrea Cacioppo",
      subtitle: "Direttore grafico del gruppo Magog",
    },
  ],
  social: {
    linkedin: "https://www.linkedin.com/company/gruppo-editoriale-magog",
    instagram: "https://www.instagram.com/gruppomagog/",
    twitter: "https://twitter.com/gruppomagog",
  },
  contact: {
    email: "info@gruppomagog.it",
  },
};
